import React from "react";
import PlusIcon from "mdi-react/PlusIcon";

export default ({ open }) => (
  <div className="roundedButton">
    <PlusIcon color="#5F39DE" onClick={open} />
  </div>
);
